import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'que-number-question-display',
    imports: [CommonModule],
    templateUrl: './number-question-display.component.html',
    styleUrls: ['./number-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberQuestionDisplayComponent {
@Input() viewAnswer = false;
}
